import { createRouteRef } from '@backstage/core-plugin-api';

export const datadogRouteRef = createRouteRef({
  id: 'datadog',
});
